import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkCategoryModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  documentCount 
}) => {
  const [selectedCategory, setSelectedCategory] = useState('');
  const [error, setError] = useState('');

  const categoryOptions = [
    { value: '', label: 'Select category...' },
    { value: 'rams', label: 'H&S Docs' },
    { value: 'insurance', label: 'Insurance' },
    { value: 'training', label: 'Training Certificates' },
    { value: 'plant', label: 'Plant Certificates' }
  ];

  const handleConfirm = () => {
    if (!selectedCategory) {
      setError('Please select a category');
      return;
    }
    onConfirm(selectedCategory);
    setSelectedCategory('');
    setError('');
  };

  const handleClose = () => {
    setSelectedCategory('');
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-modal flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-elevation-5 w-full max-w-md">
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg">
              <Icon name="FolderEdit" size={20} color="var(--color-accent)" />
            </div>
            <div>
              <h2 className="text-lg font-semibold text-foreground">Change Category</h2>
              <p className="text-sm text-muted-foreground">
                Update category for {documentCount} {documentCount === 1 ? 'document' : 'documents'}
              </p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={handleClose}
            aria-label="Close modal"
          >
            <Icon name="X" size={20} />
          </Button>
        </div>

        <div className="p-6">
          <Select
            label="New Category"
            description="All selected documents will be moved to this category"
            options={categoryOptions}
            value={selectedCategory}
            onChange={(value) => {
              setSelectedCategory(value);
              setError('');
            }}
            error={error}
            required
          />
        </div>

        <div className="flex items-center justify-end gap-3 p-4 border-t border-border">
          <Button
            variant="outline"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            iconName="Check"
            iconPosition="left"
          >
            Update Category
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkCategoryModal;